var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.401306,
    width: 64,
    height: 64,
    rx: 18.6182,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3271 24.2557L26.011 32.5719C25.9297 32.6533 25.8744 32.7569 25.852 32.8697C25.8296 32.9825 25.8411 33.0994 25.8851 33.2056C25.9291 33.3119 26.0036 33.4027 26.0992 33.4667C26.1947 33.5306 26.3071 33.5648 26.4221 33.5649H29.6803V40.5467L37.9965 32.2306C38.0778 32.1492 38.1331 32.0456 38.1555 31.9328C38.1779 31.82 38.1664 31.7031 38.1224 31.5968C38.0784 31.4906 38.0039 31.3998 37.9083 31.3358C37.8127 31.2719 37.7003 31.2377 37.5853 31.2376H34.3271V24.2557Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6995 34.7287C14.5972 33.9571 14.5459 33.1797 14.5459 32.4014C14.5459 27.7721 16.3849 23.3325 19.6582 20.0591C22.9316 16.7857 27.3713 14.9468 32.0005 14.9468",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.301 34.7287C49.4038 33.9572 49.4557 33.1797 49.4562 32.4014C49.4562 30.1091 49.0047 27.8392 48.1274 25.7214C47.2501 23.6036 45.9643 21.6794 44.3433 20.0586C42.7223 18.4377 40.798 17.1521 38.6801 16.275C36.5622 15.3979 34.2923 14.9466 32 14.9468",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 39.3709C47.4393 40.6915 46.704 41.9333 45.8184 43.065",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4522 46.3748C41.3094 47.2443 40.0575 47.9599 38.7285 48.5035",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3067 48.5035C23.9772 47.9608 22.7252 47.245 21.583 46.3748",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2134 43.065C17.3253 41.9338 16.5878 40.6921 16.0195 39.3709",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3274 49.7023C32.7827 49.9071 31.2176 49.9071 29.6729 49.7023",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSaveIcon);
export default __webpack_public_path__ + "static/media/time-save-icon.f959f771ab038707a0ae02b2c1754380.svg";
export { ForwardRef as ReactComponent };